export enum ColumnDataType {
  ArrayOfNumbers = 'arrayOfNumbers',
  ArrayOfStrings = 'arrayOfStrings',
  Boolean = 'boolean',
  Enum = 'enum',
  Expression = 'expression',
  File = 'file',
  Html = 'html',
  Image = 'image',
  Json = 'json',
  KMLMap = 'kmlMap',
  Lookup = 'lookup', // Expects a lookup table to be defined in the database.
  ForeignKey = 'foreignKey', // Signifies an actual FK relationship to another table.
  Number = 'number',
  Price = 'price',
  Range = 'range',
  StyleIcon = 'styleIcon',
  Text = 'text',
  TextLocalizable = 'textLocalizable',
  Url = 'url',
}
